import fetch from '../utils/fetch';
import { cashierURL } from 'endpoints';
const CashierSdk = require( '@nackle/cashier-sdk' );

function CashierService( accessToken, companyId ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                authorization: `Bearer ${ accessToken }`,
                'company-id': `${ companyId }`
            },
        };
        return fetch( url, options );
    };

    const sdk = new CashierSdk( cashierURL, fetchWithAuth );

    const getAccountInformation = async ( personId ) => {
        try {
            const res = await sdk.getAccountInformation( personId );

            if ( res.personId ) {
                return {
                    awardbanqNumber: res.accountNumber,
                    centraxId: res.omParticipantId
                };
            }
            throw new Error( 'Unsuccessful response from getAccountInformation' );

        } catch ( error ) {
            if ( error.status === 404 ) {
                return {
                    awardbanqNumber: null,
                    centraxId: null
                };
            }
            console.error( 'ERROR', error );
        }
    };

    const getPointBalance = async ( personId ) => {
        try {
            const res = await sdk.getPointBalance( personId );

            if ( res ) {
                return res.accountBalance;
            }
            throw new Error( 'Unsuccessful response from getPointBalance' );

        } catch ( error ) {
            if ( error.status === 404 ) {
                return null;
            }
            console.error( 'ERROR', error );
        }
    };

    return {
        getAccountInformation,
        getPointBalance
    };
}

export default CashierService;